export const UTILISATEUR_ROLE_PROPRIETAIRE = 'proprietaire';
export const UTILISATEUR_ROLE_EXPLOITANT = 'exploitant';
export const UTILISATEUR_ROLE_MOA = 'moa';
export const UTILISATEUR_ROLE_MOE = 'moe';
export const UTILISATEUR_ROLE_TIERS = 'tiers';
